module.exports = __webpack_public_path__ + "static/img/fdc-lfs.5448008.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/fdc-lfs.jpg
// module id = gkch
// module chunks = 1